module.exports = __webpack_public_path__ + "static/media/scroll-2.79449bd2.png";